import { gql } from '@apollo/client'

export const generateTikTokConnectURL = gql`
  query GenerateTikTokConnectURL($redirect: String!) {
    generateTikTokConnectURL(redirect: $redirect)
  }
`
